"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import {
  GA4DataLayer,
  GA4DataLayerFn,
} from "@packages/lib/utlils/helper-function";
import { GAConstants } from "@packages/shared-components/services/constants";

interface WuscaCtaBannerProps {
  title?: string;
  description?: string;
  buttonName?: string;
  buttonUrl?: string;
  bannerSrc?: string;
  bgColor?: string;
  // When true (e.g. on the WUSCA landing page), the click handler skips the
  // GA4DataLayerFn (wusca_bestofbest) event and only fires GA4DataLayer.
  skipBestOfBestGa?: boolean;
}

const WuscaCtaBanner = ({
  title,
  description,
  buttonName,
  buttonUrl,
  bannerSrc,
  bgColor,
  skipBestOfBestGa,
}: WuscaCtaBannerProps) => {
  const handleCtaClick = () => {
    if (!skipBestOfBestGa) {
      GA4DataLayerFn({
        event: "wusca_events",
        eventName: "wusca_bestofbest",
      });
    }
    GA4DataLayer({
      event: GAConstants.track_event,
      event_name: "redirection_link_click",
    });
  };

  return (
    <div
      className={`${bgColor || ""} p-[16px] md:py-[0] md:px-[20px] gap-[20px] rounded-[8px] flex md:flex-row flex-col-reverse justify-between items-start md:items-center md:h-[166px] !m-0 !mx-[16px] lg:!mx-0 mt-[24px]`}
    >
      <div className="flex flex-col gap-[16px] py-[0] md:py-[24px] !m-0">
        <div className="text-grey300 flex flex-col gap-[4px]">
          <div className="h4 heading4 font-semibold font-farro">{title}</div>
          <p className="font-inter font-normal small">{description}</p>
        </div>
        <Link
          href={buttonUrl || "#"}
          onClick={handleCtaClick}
          className="btn btn-primary rtfcustom-link hover:no-underline px-[20px] py-[10px] w-fit !no-underline"
        >
          {buttonName}
        </Link>
      </div>
      {bannerSrc && (
        <span className="md:min-w-[219px] w-full md:w-auto h-[187px] md:h-[166px] flex justify-center items-end !m-0">
          <Image
            className="object-contain h-full w-auto"
            src={bannerSrc}
            width={219}
            height={187}
            alt={title || ""}
          />
        </span>
      )}
    </div>
  );
};

export default WuscaCtaBanner;
